export default abstract class FirestoreDbQueries<OBJECT_CLASS> {
	instances: any[];

	constructor() {
		this.instances = [];
	}

	abstract notify(data: OBJECT_CLASS): void;
	
	subscribe(objectReference: any) {
		this.instances.push(objectReference);
	}

	unsubscribe(objectToUnsubscribe: any) {
        let index = this.instances.indexOf(objectToUnsubscribe);
        if (index !== -1) {
            this.instances.splice(index, 1);
        }
	}
	
	abstract convertFromFirestore(documentId: string, mapperObject: any): OBJECT_CLASS;
}